import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Experiência Profissional</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2025 - presente"
            iconStyle={{ background: '#000000', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Marketing Specialist & E-commerce Assistant</h3>
            <h4 className="vertical-timeline-element-subtitle">Macovex</h4>
            <p>
              Gestão de redes sociais, website e e-commerce, criação e edição de conteúdos,
              comunicação de produto, email marketing, planeamento de conteúdos e apoio
              à organização e execução de eventos.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2025 - 2025"
            iconStyle={{ background: '#000000', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Estágio Profissional em Marketing</h3>
            <h4 className="vertical-timeline-element-subtitle">Macovex</h4>
            <p>
              Apoio ao desenvolvimento de atividades de marketing e comunicação,
              criação de conteúdos, gestão de redes sociais e apoio à atualização
              e manutenção do website.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2023 - 2023"
            iconStyle={{ background: '#000000', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Estágio Profissional em Marketing</h3>
            <h4 className="vertical-timeline-element-subtitle">Termas de Alcafache</h4>
            <p>
              Apoio ao desenvolvimento de ações de marketing e comunicação,
              criação de conteúdos e desenvolvimento de atividades de comunicação
              da organização.
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;